import { get } from '../../../home24/core/registry';

export function onArticleAddedToCart(trackingData, type) {
    if (typeof window.dataLayer !== 'undefined') {

        var pageType = type || '';

        // add pageType inside product data :/
        if (trackingData.addedArticle && trackingData.addedArticle[0]) {
            trackingData.addedArticle[0].dimension65 = pageType;
            trackingData.addedArticle[0].brand = decodeURIComponent(trackingData.addedArticle[0].brand);
        }

        var dataObject = {
            event: 'addToCart',
            pageType: pageType,
            ecommerce: {
                add: {
                    products: trackingData.addedArticle
                },
                cartValue: trackingData.cartValue,
                currencyCode: get('currencyCode')
            }
        };

        window.dataLayer.push(dataObject);
    }
}



/** WEBPACK FOOTER **
 ** ./legacy/home24-shared/tracking/cart/cart.js
 **/